import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propChildren, propStr } from '../../../../helpers/custom-prop-types';
import OkIcon from '../../../Icon/Svg/OkIcon';
const ProfessionalUnitCompanySubscribeDeliveryList = (props) => {
    const { className, description } = props;
    const items = [
        '事例',
        'ダウンロード資料',
        'プロジェクト実績',
        'セミナー情報',
        '登録コンサルタント',
        'コラム',
    ];
    return (_jsxs("div", Object.assign({ className: clsx('unit_company_subscribe_delivery_list', className) }, { children: [description, _jsx("ul", Object.assign({ className: 'delivery_row' }, { children: items.map((v) => (_jsxs("li", Object.assign({ className: 'delivery_column' }, { children: [_jsx(OkIcon, { className: 'blue' }), _jsx("div", Object.assign({ className: 'delivery_text' }, { children: v }))] }), v))) }))] })));
};
ProfessionalUnitCompanySubscribeDeliveryList.propTypes = {
    className: propStr(),
    description: propChildren(),
};
ProfessionalUnitCompanySubscribeDeliveryList.defaultProps = {
    className: '',
    description: undefined,
};
export default ProfessionalUnitCompanySubscribeDeliveryList;
